var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconVisibilityLight = function SvgIconVisibilityLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.544 11.803c.431-1.01 2.394-4.853 7.46-4.853 5.07 0 7.032 3.847 7.462 4.854.123.288.123.605 0 .893-.432 1.01-2.395 4.853-7.461 4.853-5.07 0-7.032-3.847-7.461-4.854l.506-.216-.505.219a1.117 1.117 0 0 1 0-.896Zm7.46-3.753c-4.38 0-6.068 3.293-6.448 4.186l-.002.003a.049.049 0 0 0-.003.009v.004l.003.01.002.002c.38.893 2.068 4.186 6.449 4.186 4.38 0 6.068-3.293 6.449-4.186l.001-.003a.05.05 0 0 0 .003-.009v-.004a.05.05 0 0 0-.003-.01l-.001-.002c-.38-.893-2.068-4.186-6.45-4.186Z",
    fill: "#9FA4AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10.3a1.95 1.95 0 1 0 0 3.9 1.95 1.95 0 0 0 0-3.9Zm-3.05 1.95a3.05 3.05 0 1 1 6.1 0 3.05 3.05 0 0 1-6.1 0Z",
    fill: "#9FA4AB"
  })));
};
export default SvgIconVisibilityLight;